import { SkechersPoItemDetails } from "./skechers-po-item-details";

export class SkechersPoDetails {
    poNumber: string;
    SkechersPoItemDetails: SkechersPoItemDetails[]
}